export const countries = [
  { code: 'USA', itemValue: 'USA', itemLabel: 'UNITED STATES' },
  { code: 'MEX', itemValue: 'MEX', itemLabel: 'MEXICO' },
  { code: 'CAN', itemValue: 'CAN', itemLabel: 'CANADA' },
  { code: 'ARG', itemValue: 'ARG', itemLabel: 'ARGENTINA' },
  { code: 'ATG', itemValue: 'ATG', itemLabel: 'ANTIGUA AND BARBUDA' },
  { code: 'ABW', itemValue: 'ABW', itemLabel: 'ARUBA' },
  { code: 'BES', itemValue: 'BES', itemLabel: 'BONAIRE' },
  { code: 'BHS', itemValue: 'BHS', itemLabel: 'BAHAMAS' },
  { code: 'BRB', itemValue: 'BRB', itemLabel: 'BARBADOS' },
  { code: 'BLZ', itemValue: 'BLZ', itemLabel: 'BELIZE' },
  { code: 'BMU', itemValue: 'BMU', itemLabel: 'BERMUDA' },
  { code: 'BOL', itemValue: 'BOL', itemLabel: 'BOLIVIA' },
  { code: 'BRA', itemValue: 'BRA', itemLabel: 'BRAZIL' },
  { code: 'CYM', itemValue: 'CYM', itemLabel: 'CAYMAN ISLANDS' },
  { code: 'CHL', itemValue: 'CHL', itemLabel: 'CHILE' },
  { code: 'COL', itemValue: 'COL', itemLabel: 'COLOMBIA' },
  { code: 'COK', itemValue: 'COK', itemLabel: 'COOK ISLANDS' },
  { code: 'CRI', itemValue: 'CRI', itemLabel: 'COSTA RICA' },
  { code: 'CUB', itemValue: 'CUB', itemLabel: 'CUBA' },
  { code: 'CUW', itemValue: 'CUW', itemLabel: 'CURAÇAO' },
  { code: 'DMA', itemValue: 'DMA', itemLabel: 'DOMINICA' },
  { code: 'DOM', itemValue: 'DOM', itemLabel: 'DOMINICAN REPUBLIC' },
  { code: 'ECU', itemValue: 'ECU', itemLabel: 'ECUADOR' },
  { code: 'FLK', itemValue: 'FLK', itemLabel: 'FALKLAND ISLANDS (MALVINAS)' },
  { code: 'SLV', itemValue: 'SLV', itemLabel: 'EL SALVADOR' },
  { code: 'FRO', itemValue: 'FRO', itemLabel: 'FAROE ISLANDS' },
  { code: 'GLP', itemValue: 'GLP', itemLabel: 'GUADELOUPE' },
  { code: 'GTM', itemValue: 'GTM', itemLabel: 'GUATEMALA' },
  { code: 'GUF', itemValue: 'GUF', itemLabel: 'FRENCH GUIANA' },
  { code: 'GUY', itemValue: 'GUY', itemLabel: 'GUYANA' },
  { code: 'HND', itemValue: 'HND', itemLabel: 'HONDURAS' },
  { code: 'HTI', itemValue: 'HTI', itemLabel: 'HAITI' },
  { code: 'JAM', itemValue: 'JAM', itemLabel: 'JAMAICA' },
  { code: 'KNA', itemValue: 'KNA', itemLabel: 'SAINT KITTS AND NEVIS' },
  { code: 'MTQ', itemValue: 'MTQ', itemLabel: 'MARTINIQUE' },
  { code: 'NIC', itemValue: 'NIC', itemLabel: 'NICARAGUA' },
  { code: 'PAN', itemValue: 'PAN', itemLabel: 'PANAMA' },
  { code: 'PER', itemValue: 'PER', itemLabel: 'PERU' },
  { code: 'PRI', itemValue: 'PRI', itemLabel: 'PUERTO RICO' },
  { code: 'PRY', itemValue: 'PRY', itemLabel: 'PARAGUAY' },
  {
    code: 'SGS',
    itemValue: 'SGS',
    itemLabel: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS',
  },
  { code: 'SHN', itemValue: 'SHN', itemLabel: 'SAINT HELENA' },
  { code: 'SPM', itemValue: 'SPM', itemLabel: 'SAINT PIERRE AND MIQUELON' },
  { code: 'TCA', itemValue: 'TCA', itemLabel: 'TURKS AND CAICOS ISLANDS' },
  { code: 'TTO', itemValue: 'TTO', itemLabel: 'TRINIDAD AND TOBAGO' },
  { code: 'URY', itemValue: 'URY', itemLabel: 'URUGUAY' },
  {
    code: 'VCT',
    itemValue: 'VCT',
    itemLabel: 'SAINT VINCENT AND THE GRENADINES',
  },
  { code: 'VEN', itemValue: 'VEN', itemLabel: 'VENEZUELA' },
  { code: 'VGB', itemValue: 'VGB', itemLabel: 'VIRGIN ISLANDS, BRITISH' },
  { code: 'VIR', itemValue: 'VIR', itemLabel: 'VIRGIN ISLANDS, U.S.' },
  { code: 'AFG', itemValue: 'AFG', itemLabel: 'AFGHANISTAN' },
  { code: 'AGO', itemValue: 'AGO', itemLabel: 'ANGOLA' },
  { code: 'AIA', itemValue: 'AIA', itemLabel: 'ANGUILLA' },
  { code: 'ALA', itemValue: 'ALA', itemLabel: 'ALAND ISLANDS' },
  { code: 'ALB', itemValue: 'ALB', itemLabel: 'ALBANIA' },
  { code: 'AND', itemValue: 'AND', itemLabel: 'ANDORRA' },
  { code: 'ANT', itemValue: 'ANT', itemLabel: 'NETHERLANDS ANTILLES' },
  { code: 'ARE', itemValue: 'ARE', itemLabel: 'UNITED ARAB EMIRATES' },
  { code: 'ARM', itemValue: 'ARM', itemLabel: 'ARMENIA' },
  { code: 'ASM', itemValue: 'ASM', itemLabel: 'AMERICAN SAMOA' },
  { code: 'ATA', itemValue: 'ATA', itemLabel: 'ANTARCTICA' },
  { code: 'ATF', itemValue: 'ATF', itemLabel: 'FRENCH SOUTHERN TERRITORIES' },
  { code: 'AUS', itemValue: 'AUS', itemLabel: 'AUSTRALIA' },
  { code: 'AUT', itemValue: 'AUT', itemLabel: 'AUSTRIA' },
  { code: 'AZE', itemValue: 'AZE', itemLabel: 'AZERBAIJAN' },
  { code: 'BDI', itemValue: 'BDI', itemLabel: 'BURUNDI' },
  { code: 'BEL', itemValue: 'BEL', itemLabel: 'BELGIUM' },
  { code: 'BEN', itemValue: 'BEN', itemLabel: 'BENIN' },
  { code: 'BFA', itemValue: 'BFA', itemLabel: 'BURKINA FASO' },
  { code: 'BGD', itemValue: 'BGD', itemLabel: 'BANGLADESH' },
  { code: 'BGR', itemValue: 'BGR', itemLabel: 'BULGARIA' },
  { code: 'BHR', itemValue: 'BHR', itemLabel: 'BAHRAIN' },
  { code: 'BIH', itemValue: 'BIH', itemLabel: 'BOSNIA AND HERZEGOVINA' },
  { code: 'BLM', itemValue: 'BLM', itemLabel: 'SAINT BARTHELEMY' },
  { code: 'BLR', itemValue: 'BLR', itemLabel: 'BELARUS' },
  { code: 'BRN', itemValue: 'BRN', itemLabel: 'BRUNEI DARUSSALAM' },
  { code: 'BTN', itemValue: 'BTN', itemLabel: 'BHUTAN' },
  { code: 'BVT', itemValue: 'BVT', itemLabel: 'BOUVET ISLAND' },
  { code: 'BWA', itemValue: 'BWA', itemLabel: 'BOTSWANA' },
  { code: 'CAF', itemValue: 'CAF', itemLabel: 'CENTRAL AFRICAN REPUBLIC' },
  { code: 'CCK', itemValue: 'CCK', itemLabel: 'COCOS (KEELING) ISLANDS' },
  { code: 'CHE', itemValue: 'CHE', itemLabel: 'SWITZERLAND' },
  { code: 'CHN', itemValue: 'CHN', itemLabel: 'CHINA' },
  { code: 'CIV', itemValue: 'CIV', itemLabel: 'COTE DIVOIRE' },
  { code: 'CMR', itemValue: 'CMR', itemLabel: 'CAMEROON' },
  {
    code: 'COD',
    itemValue: 'COD',
    itemLabel: 'DEMOCRATIC REPUBLIC OF THE CONGO',
  },
  { code: 'COG', itemValue: 'COG', itemLabel: 'CONGO' },
  { code: 'COM', itemValue: 'COM', itemLabel: 'COMOROS' },
  { code: 'CPV', itemValue: 'CPV', itemLabel: 'CAPE VERDE' },
  { code: 'CXR', itemValue: 'CXR', itemLabel: 'CHRISTMAS ISLAND' },
  { code: 'CYP', itemValue: 'CYP', itemLabel: 'CYPRUS' },
  { code: 'CZE', itemValue: 'CZE', itemLabel: 'CZECH REPUBLIC' },
  { code: 'DEU', itemValue: 'DEU', itemLabel: 'GERMANY' },
  { code: 'DJI', itemValue: 'DJI', itemLabel: 'DJIBOUTI' },
  { code: 'DNK', itemValue: 'DNK', itemLabel: 'DENMARK' },
  { code: 'DZA', itemValue: 'DZA', itemLabel: 'ALGERIA' },
  { code: 'EGY', itemValue: 'EGY', itemLabel: 'EGYPT' },
  { code: 'ERI', itemValue: 'ERI', itemLabel: 'ERITREA' },
  { code: 'ESH', itemValue: 'ESH', itemLabel: 'WESTERN SAHARA' },
  { code: 'ESP', itemValue: 'ESP', itemLabel: 'SPAIN' },
  { code: 'EST', itemValue: 'EST', itemLabel: 'ESTONIA' },
  { code: 'ETH', itemValue: 'ETH', itemLabel: 'ETHIOPIA' },
  { code: 'FIN', itemValue: 'FIN', itemLabel: 'FINLAND' },
  { code: 'FJI', itemValue: 'FJI', itemLabel: 'FIJI' },
  { code: 'FRA', itemValue: 'FRA', itemLabel: 'FRANCE' },
  {
    code: 'FSM',
    itemValue: 'FSM',
    itemLabel: 'FEDERATED STATES OF MICRONESIA',
  },
  { code: 'GAB', itemValue: 'GAB', itemLabel: 'GABON' },
  { code: 'GBR', itemValue: 'GBR', itemLabel: 'UNITED KINGDOM' },
  { code: 'GEO', itemValue: 'GEO', itemLabel: 'GEORGIA' },
  { code: 'GGY', itemValue: 'GGY', itemLabel: 'GUERNSEY' },
  { code: 'GHA', itemValue: 'GHA', itemLabel: 'GHANA' },
  { code: 'GIB', itemValue: 'GIB', itemLabel: 'GIBRALTAR' },
  { code: 'GIN', itemValue: 'GIN', itemLabel: 'GUINEA' },
  { code: 'GMB', itemValue: 'GMB', itemLabel: 'GAMBIA' },
  { code: 'GNB', itemValue: 'GNB', itemLabel: 'GUINEA-BISSAU' },
  { code: 'GNQ', itemValue: 'GNQ', itemLabel: 'EQUATORIAL GUINEA' },
  { code: 'GRC', itemValue: 'GRC', itemLabel: 'GREECE' },
  { code: 'GRD', itemValue: 'GRD', itemLabel: 'GRENADA' },
  { code: 'GRL', itemValue: 'GRL', itemLabel: 'GREENLAND' },
  { code: 'GUM', itemValue: 'GUM', itemLabel: 'GUAM' },
  { code: 'HKG', itemValue: 'HKG', itemLabel: 'HONG KONG' },
  {
    code: 'HMD',
    itemValue: 'HMD',
    itemLabel: 'HEARD ISLAND AND MCDONALD ISLANDS',
  },
  { code: 'HRV', itemValue: 'HRV', itemLabel: 'CROATIA' },
  { code: 'HUN', itemValue: 'HUN', itemLabel: 'HUNGARY' },
  { code: 'IDN', itemValue: 'IDN', itemLabel: 'INDONESIA' },
  { code: 'IMN', itemValue: 'IMN', itemLabel: 'ISLE OF MAN' },
  { code: 'IND', itemValue: 'IND', itemLabel: 'INDIA' },
  {
    code: 'IOT',
    itemValue: 'IOT',
    itemLabel: 'BRITISH INDIAN OCEAN TERRITORY',
  },
  { code: 'IRL', itemValue: 'IRL', itemLabel: 'IRELAND' },
  { code: 'IRN', itemValue: 'IRN', itemLabel: 'ISLAMIC REPUBLIC OF IRAN' },
  { code: 'IRQ', itemValue: 'IRQ', itemLabel: 'IRAQ' },
  { code: 'ISL', itemValue: 'ISL', itemLabel: 'ICELAND' },
  { code: 'ISR', itemValue: 'ISR', itemLabel: 'ISRAEL' },
  { code: 'ITA', itemValue: 'ITA', itemLabel: 'ITALY' },
  { code: 'JEY', itemValue: 'JEY', itemLabel: 'JERSEY' },
  { code: 'JOR', itemValue: 'JOR', itemLabel: 'JORDAN' },
  { code: 'JPN', itemValue: 'JPN', itemLabel: 'JAPAN' },
  { code: 'KAZ', itemValue: 'KAZ', itemLabel: 'KAZAKHSTAN' },
  { code: 'KEN', itemValue: 'KEN', itemLabel: 'KENYA' },
  { code: 'KGZ', itemValue: 'KGZ', itemLabel: 'KYRGYZSTAN' },
  { code: 'KHM', itemValue: 'KHM', itemLabel: 'CAMBODIA' },
  { code: 'KIR', itemValue: 'KIR', itemLabel: 'KIRIBATI' },
  { code: 'KOR', itemValue: 'KOR', itemLabel: 'REPUBLIC OF KOREA' },
  { code: 'KWT', itemValue: 'KWT', itemLabel: 'KUWAIT' },
  {
    code: 'LAO',
    itemValue: 'LAO',
    itemLabel: 'LAO PEOPLE DEMOCRATIC REPUBLIC',
  },
  { code: 'LBN', itemValue: 'LBN', itemLabel: 'LEBANON' },
  { code: 'LBR', itemValue: 'LBR', itemLabel: 'LIBERIA' },
  { code: 'LBY', itemValue: 'LBY', itemLabel: 'LIBYAN ARAB JAMAHIRIYA' },
  { code: 'LCA', itemValue: 'LCA', itemLabel: 'SAINT LUCIA' },
  { code: 'LIE', itemValue: 'LIE', itemLabel: 'LIECHTENSTEIN' },
  { code: 'LKA', itemValue: 'LKA', itemLabel: 'SRI LANKA' },
  { code: 'LSO', itemValue: 'LSO', itemLabel: 'LESOTHO' },
  { code: 'LTU', itemValue: 'LTU', itemLabel: 'LITHUANIA' },
  { code: 'LUX', itemValue: 'LUX', itemLabel: 'LUXEMBOURG' },
  { code: 'LVA', itemValue: 'LVA', itemLabel: 'LATVIA' },
  { code: 'MAC', itemValue: 'MAC', itemLabel: 'MACAO' },
  { code: 'MAF', itemValue: 'MAF', itemLabel: 'SAINT MARTIN' },
  { code: 'MAR', itemValue: 'MAR', itemLabel: 'MOROCCO' },
  { code: 'MCO', itemValue: 'MCO', itemLabel: 'MONACO' },
  { code: 'MDA', itemValue: 'MDA', itemLabel: 'MOLDOVA' },
  { code: 'MDG', itemValue: 'MDG', itemLabel: 'MADAGASCAR' },
  { code: 'MDV', itemValue: 'MDV', itemLabel: 'MALDIVES' },
  { code: 'MHL', itemValue: 'MHL', itemLabel: 'MARSHALL ISLANDS' },
  { code: 'MKD', itemValue: 'MKD', itemLabel: 'MACEDONIA' },
  { code: 'MLI', itemValue: 'MLI', itemLabel: 'MALI' },
  { code: 'MLT', itemValue: 'MLT', itemLabel: 'MALTA' },
  { code: 'MMR', itemValue: 'MMR', itemLabel: 'MYANMAR' },
  { code: 'MNE', itemValue: 'MNE', itemLabel: 'MONTENEGRO' },
  { code: 'MNG', itemValue: 'MNG', itemLabel: 'MONGOLIA' },
  { code: 'MNP', itemValue: 'MNP', itemLabel: 'NORTHERN MARIANA ISLANDS' },
  { code: 'MOZ', itemValue: 'MOZ', itemLabel: 'MOZAMBIQUE' },
  { code: 'MRT', itemValue: 'MRT', itemLabel: 'MAURITANIA' },
  { code: 'MSR', itemValue: 'MSR', itemLabel: 'MONTSERRAT' },
  { code: 'MUS', itemValue: 'MUS', itemLabel: 'MAURITIUS' },
  { code: 'MWI', itemValue: 'MWI', itemLabel: 'MALAWI' },
  { code: 'MYS', itemValue: 'MYS', itemLabel: 'MALAYSIA' },
  { code: 'MYT', itemValue: 'MYT', itemLabel: 'MAYOTTE' },
  { code: 'NAM', itemValue: 'NAM', itemLabel: 'NAMIBIA' },
  { code: 'NCL', itemValue: 'NCL', itemLabel: 'NEW CALEDONIA' },
  { code: 'NER', itemValue: 'NER', itemLabel: 'NIGER' },
  { code: 'NFK', itemValue: 'NFK', itemLabel: 'NORFOLK ISLAND' },
  { code: 'NGA', itemValue: 'NGA', itemLabel: 'NIGERIA' },
  { code: 'NIU', itemValue: 'NIU', itemLabel: 'NIUE' },
  { code: 'NLD', itemValue: 'NLD', itemLabel: 'NETHERLANDS' },
  { code: 'NOR', itemValue: 'NOR', itemLabel: 'NORWAY' },
  { code: 'NPL', itemValue: 'NPL', itemLabel: 'NEPAL' },
  { code: 'NRU', itemValue: 'NRU', itemLabel: 'NAURU' },
  { code: 'NZL', itemValue: 'NZL', itemLabel: 'NEW ZEALAND' },
  { code: 'OMN', itemValue: 'OMN', itemLabel: 'OMAN' },
  { code: 'PAK', itemValue: 'PAK', itemLabel: 'PAKISTAN' },
  { code: 'PCN', itemValue: 'PCN', itemLabel: 'PITCAIRN' },
  { code: 'PHL', itemValue: 'PHL', itemLabel: 'PHILIPPINES' },
  { code: 'PLW', itemValue: 'PLW', itemLabel: 'PALAU' },
  { code: 'PNG', itemValue: 'PNG', itemLabel: 'PAPUA NEW GUINEA' },
  { code: 'POL', itemValue: 'POL', itemLabel: 'POLAND' },
  {
    code: 'PRK',
    itemValue: 'PRK',
    itemLabel: 'DEMOCRATIC PEOPLES REPUBLIC OF KOREA',
  },
  { code: 'PRT', itemValue: 'PRT', itemLabel: 'PORTUGAL' },
  { code: 'PSE', itemValue: 'PSE', itemLabel: 'PALESTINIAN TERRITORY' },
  { code: 'PYF', itemValue: 'PYF', itemLabel: 'FRENCH POLYNESIA' },
  { code: 'QAT', itemValue: 'QAT', itemLabel: 'QATAR' },
  { code: 'REU', itemValue: 'REU', itemLabel: 'RÉUNION' },
  { code: 'ROU', itemValue: 'ROU', itemLabel: 'ROMANIA' },
  { code: 'RUS', itemValue: 'RUS', itemLabel: 'RUSSIAN FEDERATION' },
  { code: 'RWA', itemValue: 'RWA', itemLabel: 'RWANDA' },
  { code: 'SAU', itemValue: 'SAU', itemLabel: 'SAUDI ARABIA' },
  { code: 'SAB', itemValue: 'SAB', itemLabel: 'SABA' },
  { code: 'BLM', itemValue: 'BLM', itemLabel: 'SAINT-BARTHELEMY' },
  { code: 'BES', itemValue: 'BES', itemLabel: 'SAINT EUSTATIUS' },
  { code: 'SDN', itemValue: 'SDN', itemLabel: 'SUDAN' },
  { code: 'SEN', itemValue: 'SEN', itemLabel: 'SENEGAL' },
  { code: 'SGP', itemValue: 'SGP', itemLabel: 'SINGAPORE' },
  { code: 'SJM', itemValue: 'SJM', itemLabel: 'SVALBARD AND JAN MAYEN' },
  { code: 'SLB', itemValue: 'SLB', itemLabel: 'SOLOMON ISLANDS' },
  { code: 'SLE', itemValue: 'SLE', itemLabel: 'SIERRA LEONE' },
  { code: 'SMR', itemValue: 'SMR', itemLabel: 'SAN MARINO' },
  { code: 'SOM', itemValue: 'SOM', itemLabel: 'SOMALIA' },
  { code: 'SRB', itemValue: 'SRB', itemLabel: 'SERBIA' },
  { code: 'STP', itemValue: 'STP', itemLabel: 'SAO TOME AND PRINCIPE' },
  { code: 'SUR', itemValue: 'SUR', itemLabel: 'SURINAME' },
  { code: 'SVK', itemValue: 'SVK', itemLabel: 'SLOVAKIA' },
  { code: 'SVN', itemValue: 'SVN', itemLabel: 'SLOVENIA' },
  { code: 'SWE', itemValue: 'SWE', itemLabel: 'SWEDEN' },
  { code: 'SWZ', itemValue: 'SWZ', itemLabel: 'SWAZILAND' },
  { code: 'SYC', itemValue: 'SYC', itemLabel: 'SEYCHELLES' },
  { code: 'SYR', itemValue: 'SYR', itemLabel: 'SYRIAN ARAB REPUBLIC' },
  { code: 'TCD', itemValue: 'TCD', itemLabel: 'CHAD' },
  { code: 'TGO', itemValue: 'TGO', itemLabel: 'TOGO' },
  { code: 'THA', itemValue: 'THA', itemLabel: 'THAILAND' },
  { code: 'TJK', itemValue: 'TJK', itemLabel: 'TAJIKISTAN' },
  { code: 'TKL', itemValue: 'TKL', itemLabel: 'TOKELAU' },
  { code: 'TKM', itemValue: 'TKM', itemLabel: 'TURKMENISTAN' },
  { code: 'TLS', itemValue: 'TLS', itemLabel: 'TIMOR-LESTE' },
  { code: 'TON', itemValue: 'TON', itemLabel: 'TONGA' },
  { code: 'TUN', itemValue: 'TUN', itemLabel: 'TUNISIA' },
  { code: 'TUR', itemValue: 'TUR', itemLabel: 'TURKEY' },
  { code: 'TUV', itemValue: 'TUV', itemLabel: 'TUVALU' },
  { code: 'TWN', itemValue: 'TWN', itemLabel: 'TAIWAN' },
  { code: 'TZA', itemValue: 'TZA', itemLabel: 'UNITED REPUBLIC OF TANZANIA' },
  { code: 'UGA', itemValue: 'UGA', itemLabel: 'UGANDA' },
  { code: 'UKR', itemValue: 'UKR', itemLabel: 'UKRAINE' },
  {
    code: 'UMI',
    itemValue: 'UMI',
    itemLabel: 'UNITED STATES MINOR OUTLYING ISLANDS',
  },
  { code: 'UZB', itemValue: 'UZB', itemLabel: 'UZBEKISTAN' },
  { code: 'VAT', itemValue: 'VAT', itemLabel: 'HOLY SEE (VATICAN CITY STATE)' },
  { code: 'VNM', itemValue: 'VNM', itemLabel: 'VIET NAM' },
  { code: 'VUT', itemValue: 'VUT', itemLabel: 'VANUATU' },
  { code: 'WLF', itemValue: 'WLF', itemLabel: 'WALLIS AND FUTUNA' },
  { code: 'WSM', itemValue: 'WSM', itemLabel: 'SAMOA' },
  { code: 'YEM', itemValue: 'YEM', itemLabel: 'YEMEN' },
  { code: 'ZAF', itemValue: 'ZAF', itemLabel: 'SOUTH AFRICA' },
  { code: 'ZMB', itemValue: 'ZMB', itemLabel: 'ZAMBIA' },
  { code: 'ZWE', itemValue: 'ZWE', itemLabel: 'ZIMBABWE' },
];

export const extendedCountryList = [
  { code: 'UNDEFINE', itemValue: 'UNDEFINE', itemLabel: 'UNDEFINE' },
  { code: 'USA', itemValue: 'USA', itemLabel: 'UNITED STATES' },
  { code: 'MEX', itemValue: 'MEX', itemLabel: 'MEXICO' },
  { code: 'CAN', itemValue: 'CAN', itemLabel: 'CANADA' },
  { code: 'ARG', itemValue: 'ARG', itemLabel: 'ARGENTINA' },
  { code: 'ATG', itemValue: 'ATG', itemLabel: 'ANTIGUA AND BARBUDA' },
  { code: 'ABW', itemValue: 'ABW', itemLabel: 'ARUBA' },
  { code: 'BHS', itemValue: 'BHS', itemLabel: 'BAHAMAS' },
  { code: 'BRB', itemValue: 'BRB', itemLabel: 'BARBADOS' },
  { code: 'BLZ', itemValue: 'BLZ', itemLabel: 'BELIZE' },
  { code: 'BMU', itemValue: 'BMU', itemLabel: 'BERMUDA' },
  { code: 'BOL', itemValue: 'BOL', itemLabel: 'BOLIVIA' },
  { code: 'BRA', itemValue: 'BRA', itemLabel: 'BRAZIL' },
  { code: 'CYM', itemValue: 'CYM', itemLabel: 'CAYMAN ISLANDS' },
  { code: 'CHL', itemValue: 'CHL', itemLabel: 'CHILE' },
  { code: 'COL', itemValue: 'COL', itemLabel: 'COLOMBIA' },
  { code: 'COK', itemValue: 'COK', itemLabel: 'COOK ISLANDS' },
  { code: 'CRI', itemValue: 'CRI', itemLabel: 'COSTA RICA' },
  { code: 'CUB', itemValue: 'CUB', itemLabel: 'CUBA' },
  { code: 'DMA', itemValue: 'DMA', itemLabel: 'DOMINICA' },
  { code: 'DOM', itemValue: 'DOM', itemLabel: 'DOMINICAN REPUBLIC' },
  { code: 'ECU', itemValue: 'ECU', itemLabel: 'ECUADOR' },
  { code: 'FLK', itemValue: 'FLK', itemLabel: 'FALKLAND ISLANDS (MALVINAS)' },
  { code: 'SLV', itemValue: 'SLV', itemLabel: 'EL SALVADOR' },
  { code: 'FRO', itemValue: 'FRO', itemLabel: 'FAROE ISLANDS' },
  { code: 'GLP', itemValue: 'GLP', itemLabel: 'GUADELOUPE' },
  { code: 'GTM', itemValue: 'GTM', itemLabel: 'GUATEMALA' },
  { code: 'GUF', itemValue: 'GUF', itemLabel: 'FRENCH GUIANA' },
  { code: 'GUY', itemValue: 'GUY', itemLabel: 'GUYANA' },
  { code: 'HND', itemValue: 'HND', itemLabel: 'HONDURAS' },
  { code: 'HTI', itemValue: 'HTI', itemLabel: 'HAITI' },
  { code: 'JAM', itemValue: 'JAM', itemLabel: 'JAMAICA' },
  { code: 'KNA', itemValue: 'KNA', itemLabel: 'SAINT KITTS AND NEVIS' },
  { code: 'MTQ', itemValue: 'MTQ', itemLabel: 'MARTINIQUE' },
  { code: 'NIC', itemValue: 'NIC', itemLabel: 'NICARAGUA' },
  { code: 'PAN', itemValue: 'PAN', itemLabel: 'PANAMA' },
  { code: 'PER', itemValue: 'PER', itemLabel: 'PERU' },
  { code: 'PRI', itemValue: 'PRI', itemLabel: 'PUERTO RICO' },
  { code: 'PRY', itemValue: 'PRY', itemLabel: 'PARAGUAY' },
  {
    code: 'SGS',
    itemValue: 'SGS',
    itemLabel: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS',
  },
  { code: 'SHN', itemValue: 'SHN', itemLabel: 'SAINT HELENA' },
  { code: 'SPM', itemValue: 'SPM', itemLabel: 'SAINT PIERRE AND MIQUELON' },
  { code: 'TCA', itemValue: 'TCA', itemLabel: 'TURKS AND CAICOS ISLANDS' },
  { code: 'TTO', itemValue: 'TTO', itemLabel: 'TRINIDAD AND TOBAGO' },
  { code: 'URY', itemValue: 'URY', itemLabel: 'URUGUAY' },
  {
    code: 'VCT',
    itemValue: 'VCT',
    itemLabel: 'SAINT VINCENT AND THE GRENADINES',
  },
  { code: 'VEN', itemValue: 'VEN', itemLabel: 'VENEZUELA' },
  { code: 'VGB', itemValue: 'VGB', itemLabel: 'VIRGIN ISLANDS, BRITISH' },
  { code: 'VIR', itemValue: 'VIR', itemLabel: 'VIRGIN ISLANDS, U.S.' },
  { code: 'AFG', itemValue: 'AFG', itemLabel: 'AFGHANISTAN' },
  { code: 'AGO', itemValue: 'AGO', itemLabel: 'ANGOLA' },
  { code: 'AIA', itemValue: 'AIA', itemLabel: 'ANGUILLA' },
  { code: 'ALA', itemValue: 'ALA', itemLabel: 'ALAND ISLANDS' },
  { code: 'ALB', itemValue: 'ALB', itemLabel: 'ALBANIA' },
  { code: 'AND', itemValue: 'AND', itemLabel: 'ANDORRA' },
  { code: 'ANT', itemValue: 'ANT', itemLabel: 'NETHERLANDS ANTILLES' },
  { code: 'ARE', itemValue: 'ARE', itemLabel: 'UNITED ARAB EMIRATES' },
  { code: 'ARM', itemValue: 'ARM', itemLabel: 'ARMENIA' },
  { code: 'ASM', itemValue: 'ASM', itemLabel: 'AMERICAN SAMOA' },
  { code: 'ATA', itemValue: 'ATA', itemLabel: 'ANTARCTICA' },
  { code: 'ATF', itemValue: 'ATF', itemLabel: 'FRENCH SOUTHERN TERRITORIES' },
  { code: 'AUS', itemValue: 'AUS', itemLabel: 'AUSTRALIA' },
  { code: 'AUT', itemValue: 'AUT', itemLabel: 'AUSTRIA' },
  { code: 'AZE', itemValue: 'AZE', itemLabel: 'AZERBAIJAN' },
  { code: 'BDI', itemValue: 'BDI', itemLabel: 'BURUNDI' },
  { code: 'BEL', itemValue: 'BEL', itemLabel: 'BELGIUM' },
  { code: 'BEN', itemValue: 'BEN', itemLabel: 'BENIN' },
  { code: 'BFA', itemValue: 'BFA', itemLabel: 'BURKINA FASO' },
  { code: 'BGD', itemValue: 'BGD', itemLabel: 'BANGLADESH' },
  { code: 'BGR', itemValue: 'BGR', itemLabel: 'BULGARIA' },
  { code: 'BHR', itemValue: 'BHR', itemLabel: 'BAHRAIN' },
  { code: 'BIH', itemValue: 'BIH', itemLabel: 'BOSNIA AND HERZEGOVINA' },
  { code: 'BLM', itemValue: 'BLM', itemLabel: 'SAINT BARTHELEMY' },
  { code: 'BLR', itemValue: 'BLR', itemLabel: 'BELARUS' },
  { code: 'BRN', itemValue: 'BRN', itemLabel: 'BRUNEI DARUSSALAM' },
  { code: 'BTN', itemValue: 'BTN', itemLabel: 'BHUTAN' },
  { code: 'BVT', itemValue: 'BVT', itemLabel: 'BOUVET ISLAND' },
  { code: 'BWA', itemValue: 'BWA', itemLabel: 'BOTSWANA' },
  { code: 'CAF', itemValue: 'CAF', itemLabel: 'CENTRAL AFRICAN REPUBLIC' },
  { code: 'CCK', itemValue: 'CCK', itemLabel: 'COCOS (KEELING) ISLANDS' },
  { code: 'CHE', itemValue: 'CHE', itemLabel: 'SWITZERLAND' },
  { code: 'CHN', itemValue: 'CHN', itemLabel: 'CHINA' },
  { code: 'CIV', itemValue: 'CIV', itemLabel: 'COTE DIVOIRE' },
  { code: 'CMR', itemValue: 'CMR', itemLabel: 'CAMEROON' },
  {
    code: 'COD',
    itemValue: 'COD',
    itemLabel: 'DEMOCRATIC REPUBLIC OF THE CONGO',
  },
  { code: 'COG', itemValue: 'COG', itemLabel: 'CONGO' },
  { code: 'COM', itemValue: 'COM', itemLabel: 'COMOROS' },
  { code: 'CPV', itemValue: 'CPV', itemLabel: 'CAPE VERDE' },
  { code: 'CXR', itemValue: 'CXR', itemLabel: 'CHRISTMAS ISLAND' },
  { code: 'CYP', itemValue: 'CYP', itemLabel: 'CYPRUS' },
  { code: 'CZE', itemValue: 'CZE', itemLabel: 'CZECH REPUBLIC' },
  { code: 'DEU', itemValue: 'DEU', itemLabel: 'GERMANY' },
  { code: 'DJI', itemValue: 'DJI', itemLabel: 'DJIBOUTI' },
  { code: 'DNK', itemValue: 'DNK', itemLabel: 'DENMARK' },
  { code: 'DZA', itemValue: 'DZA', itemLabel: 'ALGERIA' },
  { code: 'EGY', itemValue: 'EGY', itemLabel: 'EGYPT' },
  { code: 'ERI', itemValue: 'ERI', itemLabel: 'ERITREA' },
  { code: 'ESH', itemValue: 'ESH', itemLabel: 'WESTERN SAHARA' },
  { code: 'ESP', itemValue: 'ESP', itemLabel: 'SPAIN' },
  { code: 'EST', itemValue: 'EST', itemLabel: 'ESTONIA' },
  { code: 'ETH', itemValue: 'ETH', itemLabel: 'ETHIOPIA' },
  { code: 'FIN', itemValue: 'FIN', itemLabel: 'FINLAND' },
  { code: 'FJI', itemValue: 'FJI', itemLabel: 'FIJI' },
  { code: 'FRA', itemValue: 'FRA', itemLabel: 'FRANCE' },
  {
    code: 'FSM',
    itemValue: 'FSM',
    itemLabel: 'FEDERATED STATES OF MICRONESIA',
  },
  { code: 'GAB', itemValue: 'GAB', itemLabel: 'GABON' },
  { code: 'GBR', itemValue: 'GBR', itemLabel: 'UNITED KINGDOM' },
  { code: 'GEO', itemValue: 'GEO', itemLabel: 'GEORGIA' },
  { code: 'GGY', itemValue: 'GGY', itemLabel: 'GUERNSEY' },
  { code: 'GHA', itemValue: 'GHA', itemLabel: 'GHANA' },
  { code: 'GIB', itemValue: 'GIB', itemLabel: 'GIBRALTAR' },
  { code: 'GIN', itemValue: 'GIN', itemLabel: 'GUINEA' },
  { code: 'GMB', itemValue: 'GMB', itemLabel: 'GAMBIA' },
  { code: 'GNB', itemValue: 'GNB', itemLabel: 'GUINEA-BISSAU' },
  { code: 'GNQ', itemValue: 'GNQ', itemLabel: 'EQUATORIAL GUINEA' },
  { code: 'GRC', itemValue: 'GRC', itemLabel: 'GREECE' },
  { code: 'GRD', itemValue: 'GRD', itemLabel: 'GRENADA' },
  { code: 'GRL', itemValue: 'GRL', itemLabel: 'GREENLAND' },
  { code: 'GUM', itemValue: 'GUM', itemLabel: 'GUAM' },
  { code: 'HKG', itemValue: 'HKG', itemLabel: 'HONG KONG' },
  {
    code: 'HMD',
    itemValue: 'HMD',
    itemLabel: 'HEARD ISLAND AND MCDONALD ISLANDS',
  },
  { code: 'HRV', itemValue: 'HRV', itemLabel: 'CROATIA' },
  { code: 'HUN', itemValue: 'HUN', itemLabel: 'HUNGARY' },
  { code: 'IDN', itemValue: 'IDN', itemLabel: 'INDONESIA' },
  { code: 'IMN', itemValue: 'IMN', itemLabel: 'ISLE OF MAN' },
  { code: 'IND', itemValue: 'IND', itemLabel: 'INDIA' },
  {
    code: 'IOT',
    itemValue: 'IOT',
    itemLabel: 'BRITISH INDIAN OCEAN TERRITORY',
  },
  { code: 'IRL', itemValue: 'IRL', itemLabel: 'IRELAND' },
  { code: 'IRN', itemValue: 'IRN', itemLabel: 'ISLAMIC REPUBLIC OF IRAN' },
  { code: 'IRQ', itemValue: 'IRQ', itemLabel: 'IRAQ' },
  { code: 'ISL', itemValue: 'ISL', itemLabel: 'ICELAND' },
  { code: 'ISR', itemValue: 'ISR', itemLabel: 'ISRAEL' },
  { code: 'ITA', itemValue: 'ITA', itemLabel: 'ITALY' },
  { code: 'JEY', itemValue: 'JEY', itemLabel: 'JERSEY' },
  { code: 'JOR', itemValue: 'JOR', itemLabel: 'JORDAN' },
  { code: 'JPN', itemValue: 'JPN', itemLabel: 'JAPAN' },
  { code: 'KAZ', itemValue: 'KAZ', itemLabel: 'KAZAKHSTAN' },
  { code: 'KEN', itemValue: 'KEN', itemLabel: 'KENYA' },
  { code: 'KGZ', itemValue: 'KGZ', itemLabel: 'KYRGYZSTAN' },
  { code: 'KHM', itemValue: 'KHM', itemLabel: 'CAMBODIA' },
  { code: 'KIR', itemValue: 'KIR', itemLabel: 'KIRIBATI' },
  { code: 'KOR', itemValue: 'KOR', itemLabel: 'REPUBLIC OF KOREA' },
  { code: 'KWT', itemValue: 'KWT', itemLabel: 'KUWAIT' },
  {
    code: 'LAO',
    itemValue: 'LAO',
    itemLabel: 'LAO PEOPLE DEMOCRATIC REPUBLIC',
  },
  { code: 'LBN', itemValue: 'LBN', itemLabel: 'LEBANON' },
  { code: 'LBR', itemValue: 'LBR', itemLabel: 'LIBERIA' },
  { code: 'LBY', itemValue: 'LBY', itemLabel: 'LIBYAN ARAB JAMAHIRIYA' },
  { code: 'LCA', itemValue: 'LCA', itemLabel: 'SAINT LUCIA' },
  { code: 'LIE', itemValue: 'LIE', itemLabel: 'LIECHTENSTEIN' },
  { code: 'LKA', itemValue: 'LKA', itemLabel: 'SRI LANKA' },
  { code: 'LSO', itemValue: 'LSO', itemLabel: 'LESOTHO' },
  { code: 'LTU', itemValue: 'LTU', itemLabel: 'LITHUANIA' },
  { code: 'LUX', itemValue: 'LUX', itemLabel: 'LUXEMBOURG' },
  { code: 'LVA', itemValue: 'LVA', itemLabel: 'LATVIA' },
  { code: 'MAC', itemValue: 'MAC', itemLabel: 'MACAO' },
  { code: 'MAF', itemValue: 'MAF', itemLabel: 'SAINT MARTIN' },
  { code: 'MAR', itemValue: 'MAR', itemLabel: 'MOROCCO' },
  { code: 'MCO', itemValue: 'MCO', itemLabel: 'MONACO' },
  { code: 'MDA', itemValue: 'MDA', itemLabel: 'MOLDOVA' },
  { code: 'MDG', itemValue: 'MDG', itemLabel: 'MADAGASCAR' },
  { code: 'MDV', itemValue: 'MDV', itemLabel: 'MALDIVES' },
  { code: 'MHL', itemValue: 'MHL', itemLabel: 'MARSHALL ISLANDS' },
  { code: 'MKD', itemValue: 'MKD', itemLabel: 'MACEDONIA' },
  { code: 'MLI', itemValue: 'MLI', itemLabel: 'MALI' },
  { code: 'MLT', itemValue: 'MLT', itemLabel: 'MALTA' },
  { code: 'MMR', itemValue: 'MMR', itemLabel: 'MYANMAR' },
  { code: 'MNE', itemValue: 'MNE', itemLabel: 'MONTENEGRO' },
  { code: 'MNG', itemValue: 'MNG', itemLabel: 'MONGOLIA' },
  { code: 'MNP', itemValue: 'MNP', itemLabel: 'NORTHERN MARIANA ISLANDS' },
  { code: 'MOZ', itemValue: 'MOZ', itemLabel: 'MOZAMBIQUE' },
  { code: 'MRT', itemValue: 'MRT', itemLabel: 'MAURITANIA' },
  { code: 'MSR', itemValue: 'MSR', itemLabel: 'MONTSERRAT' },
  { code: 'MUS', itemValue: 'MUS', itemLabel: 'MAURITIUS' },
  { code: 'MWI', itemValue: 'MWI', itemLabel: 'MALAWI' },
  { code: 'MYS', itemValue: 'MYS', itemLabel: 'MALAYSIA' },
  { code: 'MYT', itemValue: 'MYT', itemLabel: 'MAYOTTE' },
  { code: 'NAM', itemValue: 'NAM', itemLabel: 'NAMIBIA' },
  { code: 'NCL', itemValue: 'NCL', itemLabel: 'NEW CALEDONIA' },
  { code: 'NER', itemValue: 'NER', itemLabel: 'NIGER' },
  { code: 'NFK', itemValue: 'NFK', itemLabel: 'NORFOLK ISLAND' },
  { code: 'NGA', itemValue: 'NGA', itemLabel: 'NIGERIA' },
  { code: 'NIU', itemValue: 'NIU', itemLabel: 'NIUE' },
  { code: 'NLD', itemValue: 'NLD', itemLabel: 'NETHERLANDS' },
  { code: 'NOR', itemValue: 'NOR', itemLabel: 'NORWAY' },
  { code: 'NPL', itemValue: 'NPL', itemLabel: 'NEPAL' },
  { code: 'NRU', itemValue: 'NRU', itemLabel: 'NAURU' },
  { code: 'NZL', itemValue: 'NZL', itemLabel: 'NEW ZEALAND' },
  { code: 'OMN', itemValue: 'OMN', itemLabel: 'OMAN' },
  { code: 'PAK', itemValue: 'PAK', itemLabel: 'PAKISTAN' },
  { code: 'PCN', itemValue: 'PCN', itemLabel: 'PITCAIRN' },
  { code: 'PHL', itemValue: 'PHL', itemLabel: 'PHILIPPINES' },
  { code: 'PLW', itemValue: 'PLW', itemLabel: 'PALAU' },
  { code: 'PNG', itemValue: 'PNG', itemLabel: 'PAPUA NEW GUINEA' },
  { code: 'POL', itemValue: 'POL', itemLabel: 'POLAND' },
  {
    code: 'PRK',
    itemValue: 'PRK',
    itemLabel: 'DEMOCRATIC PEOPLES REPUBLIC OF KOREA',
  },
  { code: 'PRT', itemValue: 'PRT', itemLabel: 'PORTUGAL' },
  { code: 'PSE', itemValue: 'PSE', itemLabel: 'PALESTINIAN TERRITORY' },
  { code: 'PYF', itemValue: 'PYF', itemLabel: 'FRENCH POLYNESIA' },
  { code: 'QAT', itemValue: 'QAT', itemLabel: 'QATAR' },
  { code: 'REU', itemValue: 'REU', itemLabel: 'RÉUNION' },
  { code: 'ROU', itemValue: 'ROU', itemLabel: 'ROMANIA' },
  { code: 'RUS', itemValue: 'RUS', itemLabel: 'RUSSIAN FEDERATION' },
  { code: 'RWA', itemValue: 'RWA', itemLabel: 'RWANDA' },
  { code: 'SAU', itemValue: 'SAU', itemLabel: 'SAUDI ARABIA' },
  { code: 'SDN', itemValue: 'SDN', itemLabel: 'SUDAN' },
  { code: 'SEN', itemValue: 'SEN', itemLabel: 'SENEGAL' },
  { code: 'SGP', itemValue: 'SGP', itemLabel: 'SINGAPORE' },
  { code: 'SJM', itemValue: 'SJM', itemLabel: 'SVALBARD AND JAN MAYEN' },
  { code: 'SLB', itemValue: 'SLB', itemLabel: 'SOLOMON ISLANDS' },
  { code: 'SLE', itemValue: 'SLE', itemLabel: 'SIERRA LEONE' },
  { code: 'SMR', itemValue: 'SMR', itemLabel: 'SAN MARINO' },
  { code: 'SOM', itemValue: 'SOM', itemLabel: 'SOMALIA' },
  { code: 'SRB', itemValue: 'SRB', itemLabel: 'SERBIA' },
  { code: 'STP', itemValue: 'STP', itemLabel: 'SAO TOME AND PRINCIPE' },
  { code: 'SUR', itemValue: 'SUR', itemLabel: 'SURINAME' },
  { code: 'SVK', itemValue: 'SVK', itemLabel: 'SLOVAKIA' },
  { code: 'SVN', itemValue: 'SVN', itemLabel: 'SLOVENIA' },
  { code: 'SWE', itemValue: 'SWE', itemLabel: 'SWEDEN' },
  { code: 'SWZ', itemValue: 'SWZ', itemLabel: 'SWAZILAND' },
  { code: 'SYC', itemValue: 'SYC', itemLabel: 'SEYCHELLES' },
  { code: 'SYR', itemValue: 'SYR', itemLabel: 'SYRIAN ARAB REPUBLIC' },
  { code: 'TCD', itemValue: 'TCD', itemLabel: 'CHAD' },
  { code: 'TGO', itemValue: 'TGO', itemLabel: 'TOGO' },
  { code: 'THA', itemValue: 'THA', itemLabel: 'THAILAND' },
  { code: 'TJK', itemValue: 'TJK', itemLabel: 'TAJIKISTAN' },
  { code: 'TKL', itemValue: 'TKL', itemLabel: 'TOKELAU' },
  { code: 'TKM', itemValue: 'TKM', itemLabel: 'TURKMENISTAN' },
  { code: 'TLS', itemValue: 'TLS', itemLabel: 'TIMOR-LESTE' },
  { code: 'TON', itemValue: 'TON', itemLabel: 'TONGA' },
  { code: 'TUN', itemValue: 'TUN', itemLabel: 'TUNISIA' },
  { code: 'TUR', itemValue: 'TUR', itemLabel: 'TURKEY' },
  { code: 'TUV', itemValue: 'TUV', itemLabel: 'TUVALU' },
  { code: 'TWN', itemValue: 'TWN', itemLabel: 'TAIWAN' },
  { code: 'TZA', itemValue: 'TZA', itemLabel: 'UNITED REPUBLIC OF TANZANIA' },
  { code: 'UGA', itemValue: 'UGA', itemLabel: 'UGANDA' },
  { code: 'UKR', itemValue: 'UKR', itemLabel: 'UKRAINE' },
  {
    code: 'UMI',
    itemValue: 'UMI',
    itemLabel: 'UNITED STATES MINOR OUTLYING ISLANDS',
  },
  { code: 'UZB', itemValue: 'UZB', itemLabel: 'UZBEKISTAN' },
  { code: 'VAT', itemValue: 'VAT', itemLabel: 'HOLY SEE (VATICAN CITY STATE)' },
  { code: 'VNM', itemValue: 'VNM', itemLabel: 'VIET NAM' },
  { code: 'VUT', itemValue: 'VUT', itemLabel: 'VANUATU' },
  { code: 'WLF', itemValue: 'WLF', itemLabel: 'WALLIS AND FUTUNA' },
  { code: 'WSM', itemValue: 'WSM', itemLabel: 'SAMOA' },
  { code: 'YEM', itemValue: 'YEM', itemLabel: 'YEMEN' },
  { code: 'ZAF', itemValue: 'ZAF', itemLabel: 'SOUTH AFRICA' },
  { code: 'ZMB', itemValue: 'ZMB', itemLabel: 'ZAMBIA' },
  { code: 'ZWE', itemValue: 'ZWE', itemLabel: 'ZIMBABWE' },
];
